import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=0be95536&scoped=true"
import script from "./MeetingDetails.vue?vue&type=script&lang=js"
export * from "./MeetingDetails.vue?vue&type=script&lang=js"
import style0 from "./MeetingDetails.vue?vue&type=style&index=0&id=0be95536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be95536",
  null
  
)

export default component.exports